import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
// import { listarFluidos  } from '../../services/api';
import { listarFluidos  } from '../../services/apigateway';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import ProcessandoModal from '../../components/Processamento/processamento';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';

import Axios from 'axios';

export default function Fluidos(){
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [fluidos, setFluidos] = useState([]);
  const [fluidoFiltrado, setFluidoFiltrado] = useState([]);
  const [fluidoPaginado, setFluidoPaginado] = useState([]);

  const [loading, setLoading] = useState(true);

  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    {
      coluna: 'cod_fluido',
      cabecalho: 'Código', 
      alinhamento: 'tdtabela'
    },
    {
      coluna: 'nom_fluido',
      cabecalho: 'Nome', 
      alinhamento: 'tdtabelaleft'
    },
    {
      coluna: 'sit_fluido',
      cabecalho: 'Situação', 
      alinhamento: 'tdtabela'
    }, 
    {
      coluna: 'ação',
      cabecalho: 'Ação',
      alinhamento: 'tdtabela'
    }
  ];

  useEffect(() => {
      loadFluidos();
      return() => {}
  }, []);

  async function loadFluidos(){
    const url = Globais.url_consulta
    const tabela = "Tab_Fluidos";
    const campos = "cod_fluido, nom_fluido, sit_fluido";
    const condicao = "cod_cliente = " + clienteId;
    const orderBy = "cod_fluido";    

    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }

      const result = await listarFluidos(clienteId);

      setFluidos(result);

      let dados = filterFluidos(result, '');
      setFluidoFiltrado(dados);
   
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarFluidos(dados, 0, qtdLinhas);
      setFluidoPaginado(datas);
      setLoading(false);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);
    }

    setLoading(false);
  }

  function filterFluidos(dados, texto) {
    let data = [];
    // console.log("dados em fluidos.js: ", dados);
    
    dados && dados.filter(item => {return item.nom_fluido.toLowerCase().includes(texto)}).map(dado => {
      data.push(dado)
    });

    return data; 
  }  
 
  function paginarFluidos(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(texto) {
    let dados = filterFluidos(fluidos, texto);
    setFluidoFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarFluidos(dados, 0, qtdLinhas)
    setFluidoPaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarFluidos(fluidoFiltrado, posicao, qtdLinhas);
    setFluidoPaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = fluidoFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(fluidoFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarFluidos(fluidoFiltrado, 0, valor);
    setFluidoPaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    // console.log('Coluna: ', coluna);
    // console.log('Ordem: ', ordem );
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...fluidoFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setFluidoFiltrado(dataCopy); 

    let data = paginarFluidos(dataCopy, 0, qtdLinhas);
    setFluidoPaginado(data); 
    setCurrentPage(0); 
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Fluidos'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando Fluidos..." />
        </section>
      </main>
    </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo 
          tela={'Cadastro de Fluidos'} 
          destination='/fluidos/inclusao/'
          permissao='FLUIDO_INCLUIR'
        />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <div>  
            <div className="flex flex items-center gap-4 p-2">
              <label>Fluido:</label>
              <div className="single-input">
                <input 
                  type="text" 
                  id='nome' 
                  name='nome' 
                  placeholder='Nome do Fluido' 
                  className='p-2 border border-gray-300 rounded-md' 
                  autoComplete='nome' 
                  onChange={e => handleSearch(e.target.value)}
                />
              </div>
            </div>


            <Tabela
              entidade='Fluidos' 
              dados={fluidoPaginado}
              elementos={elementos}
              handleSort={handleSort}
              sortedId={coluna}
              ordem={ordem}
              urlBase='/fluidos'
            />

            {qtdPaginas > 1 ? (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {fluidoFiltrado.length} 
                />
                
                <Paginate
                  qtdPaginas={qtdPaginas}
                  handlePageClick={handlePageClick}
                  currentPage={currentPage}
                />

              </div>
            ) : (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {fluidoFiltrado.length} 
                />
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
    );
  }
  